<template>
  <div class="sample-detail-secondary-results">
    <div class="input-row">
      <SampleDetailParticleControl
        label="Nitrate"
        propName="nitrateDisplay"
        propAverageName="averageNitrate"
        propSeverityName="nitrateSeverityID"
        :tabindex="200"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Phosphate"
        propName="phosphateDisplay"
        propAverageName="averagePhosphate"
        propSeverityName="phosphateSeverityID"
        :tabindex="250"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Color"
        propName="color"
        propSeverityName="colorSeverityID"
        :tabindex="202"
        :showAverageResults="false"
        :formData="sampleData"
        :includeAverage="false"
        :isNumeric="false"
        :isMeasurement="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Sulfate"
        propName="sulfateDisplay"
        propAverageName="averageSulfate"
        propSeverityName="sulfateSeverityID"
        :tabindex="252"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleAutoCompleteControl
        propSeverityName="claritySeverityID"
        :tabindex="-1"
        :formData="sampleData"
        :mappings="mappings"
      >
        <AutoComplete
          :formData="sampleData"
          :allowEmpty="false"
          :tabindex="204"
          store="Clarity"
          :mapping="mappings.Clarity"
          placeholder=""
        >
          Clarity
        </AutoComplete>
      </SampleDetailParticleAutoCompleteControl>
      <SampleDetailParticleControl
        label="Oxalate"
        propName="oxalateDisplay"
        propAverageName="averageOxalate"
        propSeverityName="oxalateSeverityID"
        :tabindex="254"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      >
      </SampleDetailParticleControl>
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="D1287 pH"
        propName="phDisplay"
        propAverageName="averagePh"
        propSeverityName="phSeverityID"
        :tabindex="206"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Acetate"
        propName="acetateDisplay"
        propAverageName="averageAcetate"
        propSeverityName="acetateSeverityID"
        :tabindex="256"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Boil Point"
        propName="boilPointDisplay"
        propAverageName="averageBoilPoint"
        propSeverityName="boilPointSeverityID"
        :tabindex="208"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Formate"
        propName="formateDisplay"
        propAverageName="averageFormate"
        propSeverityName="formateSeverityID"
        :tabindex="258"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="TDS"
        propName="tdsDisplay"
        propAverageName="averageTds"
        propSeverityName="tdsSeverityID"
        :tabindex="210"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Glycolate"
        propName="glycolateDisplay"
        propAverageName="averageGlycolate"
        propSeverityName="glycolateSeverityID"
        :tabindex="260"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Conductivity"
        propName="specificConductanceDisplay"
        propAverageName="averageSpecificConductance"
        propSeverityName="specificConductanceSeverityID"
        :tabindex="212"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Fluoride"
        propName="fluorideDisplay"
        propAverageName="averageFluoride"
        propSeverityName="fluorideSeverityID"
        :tabindex="262"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Freeze Point"
        propName="freezePointDisplay"
        propAverageName="averageFreezePoint"
        propSeverityName="freezePointSeverityID"
        :tabindex="214"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Chloride"
        propName="chlorideDisplay"
        propAverageName="averageChloride"
        propSeverityName="chlorideSeverityID"
        :tabindex="264"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Glycol Percent"
        propName="antifreezePercentDisplay"
        propAverageName="averageAntifreezePercent"
        propSeverityName="antifreezePercentSeverityID"
        :tabindex="216"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleControl
        label="Nitrite"
        propName="nitriteDisplay"
        propAverageName="averageNitrite"
        propSeverityName="nitriteSeverityID"
        :tabindex="266"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Hardness"
        propName="hardnessDisplay"
        propAverageName="averageHardness"
        propSeverityName="hardnessSeverityID"
        :tabindex="218"
        :showAverageResults="showAverageResults"
        :formData="sampleData"
        :isNumeric="false"
        :mappings="mappings"
      />
      <SampleDetailParticleAutoCompleteControl
        propSeverityName="elcPassFailSeverityID"
        :tabindex="-1"
        :formData="sampleData"
        :mappings="mappings"
      >
        <AutoComplete
          :formData="sampleData"
          :allowEmpty="false"
          :tabindex="268"
          store="Elc"
          :mapping="mappings.Elc"
          placeholder="Pass/Fail"
        >
          ELC
        </AutoComplete>
      </SampleDetailParticleAutoCompleteControl>
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Odor"
        propName="odor"
        :tabindex="220"
        :showAverageResults="false"
        :formData="sampleData"
        :isNumeric="false"
        :isMeasurement="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleAutoCompleteControl
        propSeverityName="magneticPrecipitateSeverityID"
        :tabindex="-1"
        :formData="sampleData"
        :mappings="mappings"
      >
        <AutoComplete
          :allowEmpty="false"
          :formData="sampleData"
          :tabindex="222"
          store="Precipitate"
          :mapping="mappings.MagneticPrecipitate"
          placeholder=""
        >
          Mag Precip
        </AutoComplete>
      </SampleDetailParticleAutoCompleteControl>
    </div>
    <div class="input-row">
      <SampleDetailParticleAutoCompleteControl
        propSeverityName="nonMagneticPrecipitateSeverityID"
        :tabindex="-1"
        :formData="sampleData"
        :mappings="mappings"
      >
        <AutoComplete
          :allowEmpty="false"
          :formData="sampleData"
          :tabindex="224"
          store="Precipitate"
          :mapping="mappings.NonMagneticPrecipitate"
          placeholder=""
        >
          Non-Mag Precip
        </AutoComplete>
      </SampleDetailParticleAutoCompleteControl>
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Fuel"
        propName="fuel"
        :tabindex="226"
        :showAverageResults="false"
        :formData="sampleData"
        :isNumeric="false"
        :isMeasurement="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleControl
        label="Foam"
        propName="foam"
        :tabindex="228"
        :showAverageResults="false"
        :formData="sampleData"
        :isNumeric="false"
        :isMeasurement="false"
        :mappings="mappings"
      />
    </div>
    <div class="input-row">
      <SampleDetailParticleAutoCompleteControl
        propSeverityName="oilSeverityID"
        :tabindex="-1"
        :formData="sampleData"
        :mappings="mappings"
      >
        <AutoComplete
          :formData="sampleData"
          :allowEmpty="false"
          :tabindex="230"
          store="OilResult"
          :mapping="mappings.OilResult"
          placeholder=""
        >
          Oil Result
        </AutoComplete>
      </SampleDetailParticleAutoCompleteControl>
    </div>
  </div>
</template>

<script>
import SampleDetailParticleControl from './CoolantSampleResultParticleControl.vue';
import SampleDetailParticleAutoCompleteControl from './CoolantSampleResultParticleAutoCompleteControl.vue';
import AutoComplete from '../../shared/AutoComplete.vue';

export default {
  name: 'SampleDetailSecondaryResults',
  props: {
    sampleData: {
      type: Object,
      default() {
        return {};
      }
    },
    showAverageResults: {
      type: Boolean
    },
    mappings: {
      type: Object,
      required: true
    }
  },
  components: {
    AutoComplete,
    SampleDetailParticleAutoCompleteControl,
    SampleDetailParticleControl
  }
};
</script>

<style lang="scss" scoped>
.sample-detail-secondary-results {
  padding: 10px;

  .input-row {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
  }
}
</style>
